import React, { useState } from 'react';
import AdminLayout from '../layouts/AdminLayout.jsx';
import AdminUsers from '../components/Admin/AdminUsers.jsx';
import AdminAttendance from '../components/Admin/AdminAttendance.jsx';
import AdminOthers from '../components/Admin/AdminOthers.jsx';
import { useLocation, Redirect } from 'react-router';
const Admin = () => {
  const [toDisplay, settoDisplay] = useState('users');
  const location = useLocation();

  const adminUID = location.state ? location.state.userUID : null;
  const handleToDisplay = (value) => {
    settoDisplay(value);
  };
  if (!adminUID) {
    return <Redirect to='/' />;
  }
  return (
    <div>
      <AdminLayout toDisplay={toDisplay} changeToDisplay={handleToDisplay}>
        {toDisplay === 'users' && <AdminUsers />}
        {toDisplay === 'attendance' && <AdminAttendance />}
        {toDisplay === 'others' && <AdminOthers />}
      </AdminLayout>
    </div>
  );
};

export default Admin;

/*

A way to change user profile info
A way to see current signed in users (calendar that only has for the month)
A way to change the classes info(less important)


*/
